<template>
  <div class="container">
    <el-form inline :model="formData">
      <el-form-item :label="$t('Status')">
        <el-select
          v-model="formData.IsEnable"
           :placeholder="$t('Status')"
          style="width: 150px"
          clearable
        >
          <el-option :label="$t('Open')" :value="1"></el-option>
          <el-option :label="$t('TurnOff')" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getData">{{$t('Search')}}</el-button>
        <el-button type="primary" @click="addData">{{$t('newAnnouncementAreation')}}</el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-table
        :data="tableData"
        border
        class="table"
        :cell-style="{ padding: '0' }"
      >
        <el-table-column
          align="center"
          prop="SellerName"
          :label="$t('OperatorName')"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="ChannelId"
          :label="$t('ChannelID')"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="ChannelName"
          :label="$t('ChannelName1')"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="TgRobotUserName"
          :label="$t('BotName')"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="KefuTgUserName"
          :label="$t('CustomerServiceTGAccount')"
          width="200"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="GameUrl"
          :label="$t('GameLink')"
          width="250"
        ></el-table-column>
        <!-- <el-table-column align="center" :label="$t('WhethertoBonus')" width="180">
          <template slot-scope="scope">
            <el-switch
              @change="changeTiYanJin(scope.row)"
              v-model="tableData[scope.$index].Ischecked"
              :inactive-text="
                tableData[scope.$index].Ischecked ? $t('Open') : $t('TurnOff')
              "
            ></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column
          align="center"
          :label="$t('AutoIssuanceSecondBonus')"
          width="180"
        >
          <template slot-scope="scope">
            <el-switch
              @change="onChangeStatusAutoTyj2(scope.row)"
              v-model="tableData[scope.$index].IsAotoTyj2Checked"
              :inactive-text="
                tableData[scope.$index].IsAotoTyj2Checked ? $t('Open') : $t('TurnOff')
              "
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('Status')" width="180">
          <template slot-scope="scope">
            <el-switch
              @change="changeStatus(scope.row)"
              v-model="tableData[scope.$index].checked"
              :inactive-text="tableData[scope.$index].checked ? $t('Open') : $t('TurnOff')"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column align="center" width="180" :label="$t('SameIP')">
          <template slot="header">
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                {{$t('IpRestrictionWarning')}}
              </div>
              <div style="display: inline-block">
                <span style="margin-right: 5px">{{$t('SameIP')}}</span>
                <span class="el-icon-question"></span>
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch
              @change="changeIpLimitStatus(scope.row)"
              v-model="tableData[scope.$index].IsIPLimitChecked"
              :inactive-text="
                tableData[scope.$index].IsIPLimitChecked ? $t('Open') : $t('TurnOff')
              "
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" width="180" :label="$t('SameDeviceCodeLimitSwitch')">
          <template slot="header">
            <el-tooltip effect="dark" placement="top">
              <div slot="content">{{ $t('AfterLimitEnableSameDeviceCodePlayersCannotReceiveTrialBonus') }}</div>
              <div style="display: inline-block">
                <span style="margin-right: 5px">{{ $t('SameDeviceCodeLimitSwitch') }}</span>
                <span class="el-icon-question"></span>
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch
              @change="OnChangeDeviceLimitStatus(scope.row)"
              v-model="tableData[scope.$index].IsDeviceLimitChecked"
              :inactive-text="
                tableData[scope.$index].IsDeviceLimitChecked ? $t('Open') : $t('TurnOff')
              "
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" width="180" :label="$t('LinkedSwitch')">
          <template slot="header">
            <el-tooltip effect="dark" placement="top">
              <div slot="content">{{$t('AddressRestrictionWarning')}}</div>
              <div style="display: inline-block">
                <span style="margin-right: 5px">{{$t('LinkedSwitch')}}</span>
                <span class="el-icon-question"></span>
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch
              @change="OnChangeAddressLimitStatus(scope.row)"
              v-model="tableData[scope.$index].IsAddressLimitChecked"
              :inactive-text="
                tableData[scope.$index].IsAddressLimitChecked ? $t('Open') : $t('TurnOff')
              "
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="CreatedAt"
          :label="$t('CreationTime')"
          width="150"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="UpdatedAt"
          :label="$t('Modification time')"
          width="150"
        ></el-table-column>
        <el-table-column  :label="$t('Actions')" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">{{$t('Edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :page-sizes="pagesizes"
        :current-page="current_row"
      >
      </el-pagination>
    </div>
    <!-- 新增/编辑 -->
    <EnAddData
      v-if="dialogData.show"
      :dialogData="dialogData"
      @success="getData"
    />
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
import EnAddData from "./EnAddData.vue";
export default {
  name: "en_reception_robot",
  extends: base,
  components: { EnAddData },
  data() {
    return {
      formData: {
        IsEnable: "",
      },
      tableData: [],
      dialogData: {
        show: false,
        title: "",
        row: {},
      },
      mTgRobotType: this.$global.ETgRobotType.E_EnRobot,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const data = {
        page: this.page,
        pagesize: this.pagesize,
        SellerId: this.filters.SellerId,
        IsEnable: Number(this.formData.IsEnable),
        TgRobotType: this.mTgRobotType,
      };
      app.post("/tgRobot/list", data, (res) => {
        this.tableData = res.data.data || [];
        this.total = res.data.total;
        this.tableData.forEach((item) => {
          item.checked = item.IsEnable == 1 ? true : false;
          item.Ischecked = true; // 固定有 item.IsTiyanjin == 1 ? true : false;
          item.IsAotoTyj2Checked = item.IsAotoTyj2 == 1 ? true : false;
          item.IsIPLimitChecked = item.IsIPRestriction == 1 ? true : false;
          item.IsDeviceLimitChecked =
            item.IsDeviceRestriction == 1 ? true : false;
          item.IsAddressLimitChecked =
            item.IsWalletRestriction == 1 ? true : false;
          item.UpdatedAt = this.$moment(item.UpdatedAt).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          item.CreatedAt = this.$moment(item.CreatedAt).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });
      });
    },
    // 新增
    addData() {
      this.dialogData.show = true;
      this.dialogData.title = this.$t('newAnnouncementAreation')
    },
    //编辑
    edit(row) {
      this.dialogData.show = true;
      this.dialogData.title = this.$t('Edit');
      this.dialogData.row = row;
    },
    // 体验金状态
    changeTiYanJin(val) {
      //console.log(val);
      app.getGoogleCode((GoogleCode) => {
        let data = {
          SellerId: val.SellerId,
          IsTiyanjin: 1, // 固定有 val.IsTiyanjin == 1 ? 2 : 1,
          GoogleCode: GoogleCode,
          Id: val.Id,
          TgRobotType: this.mTgRobotType,
        };
        app.post("/tgRobot/update_tiyanjin_status", data, (result) => {
          if (result.code == 200) {
            this.$message.success(this.$t('EditSuccess'));
            this.getData();
          }
        });
      });
    },
    // 是否自动发放（第二笔体验金）
    onChangeStatusAutoTyj2(pVal) {
      //console.log("onChangeStatusAutoTyj2 = ", pVal);
      app.getGoogleCode((GoogleCode) => {
        let data = {
          SellerId: pVal.SellerId,
          IsAotoTyj2: pVal.IsAotoTyj2 == 1 ? 2 : 1,
          GoogleCode: GoogleCode,
          Id: pVal.Id,
          TgRobotType: this.mTgRobotType,
        };
        app.post("/tgRobot/update_IsAotoTyj2", data, (result) => {
          if (result.code == 200) {
            this.$message.success(this.$t('EditSuccess'));
            this.getData();
          }
        });
      });
    },
    // 修改状态
    changeStatus(val) {
      app.getGoogleCode((GoogleCode) => {
        let data = {
          SellerId: val.SellerId,
          IsEnable: val.IsEnable == 1 ? 2 : 1,
          GoogleCode: GoogleCode,
          Id: val.Id,
          TgRobotType: this.mTgRobotType,
        };
        app.post("/tgRobot/update_status", data, (result) => {
          if (result.code == 200) {
            this.$message.success(this.$t('EditSuccess'));
            this.getData();
          }
        });
      });
    },
    // 修改同IP限制状态
    changeIpLimitStatus(pVal) {
      app.getGoogleCode((GoogleCode) => {
        let data = {
          SellerId: pVal.SellerId,
          IsIPRestriction: pVal.IsIPRestriction == 1 ? 2 : 1,
          GoogleCode: GoogleCode,
          Id: pVal.Id,
          TgRobotType: this.mTgRobotType,
        };
        app.post("/tgRobot/update_ip_restriction_status", data, (result) => {
          if (result.code == 200) {
            this.$message.success(this.$t('EditSuccess'));
            this.getData();
          }
        });
      });
    },
    OnChangeDeviceLimitStatus(pRow) {
      app.getGoogleCode((pGoogleCode) => {
        let tData = app.clone(pRow);
        tData.IsDeviceRestriction = pRow.IsDeviceRestriction == 1 ? 2 : 1;
        tData.GoogleCode = pGoogleCode;
        this.OnChangeStatus(tData);
      });
    },
    OnChangeAddressLimitStatus(pRow) {
      app.getGoogleCode((pGoogleCode) => {
        let tData = app.clone(pRow);
        tData.IsWalletRestriction = pRow.IsWalletRestriction == 1 ? 2 : 1;
        tData.GoogleCode = pGoogleCode;
        this.OnChangeStatus(tData);
      });
    },
    OnChangeStatus(pData) {
      delete pData.ChannelName;
      delete pData.CreatedAt;
      delete pData.SellerName;
      delete pData.UpdatedAt;

      app.post("/tgRobot/update", pData, (res) => {
        if (res.code == 200) {
          this.$message.success(this.$t('EditSuccess'));
          this.getData();
        }
      });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
  },
};
</script>

<style scoped>
::v-deep .el-switch__label.is-active {
  color: red;
}

::v-deep .el-switch__label {
  color: #409eff;
}
</style>
